import { Value } from 'interfaces';

const textDecider = (value: Value, user_name: string): string => {
  let text;
  switch (value) {
    case 'LEAD':
      text = `${user_name} marked it as `;
      break;
    case 'IN_PROGRESS':
      text = `${user_name} moved it in `;
      break;
    case 'MADE_OFFER':
      text = `${user_name} updated it to `;
      break;
    case 'DEAL_CLOSED_SUCCESS':
      text = `${user_name} `;
      break;
    case 'DEAL_FAILED':
      text = `${user_name} `;
      break;
    default:
      text = '';
      break;
  }
  return text;
};
export default textDecider;
